module.exports = __webpack_public_path__ + "img/Klarna_200x104.f471f32.svg";